// @owners { team: patient-health }
import { type RouteParams, useNavigation } from '@alto/navigation';
import { TypescriptUtils } from '~shared/TypescriptUtils';
import { getPlatformOS } from '~shared/helpers/getPlatformOS';
import { getRouteState } from '~shared/selectors/getRouteState';
import { useSelectorShared } from '~shared/store';

const isWeb = getPlatformOS() === 'web';

export const useNavigationParams = <RouteKey extends keyof RouteParams>(
  defaultValuesByParam: Partial<RouteParams[RouteKey]>,
) => {
  const routeState: RouteParams[RouteKey] = useSelectorShared(getRouteState);
  const { getParam } = useNavigation<RouteKey>();
  return TypescriptUtils.objectKeys(defaultValuesByParam).reduce((acc, key) => {
    const value = isWeb ? routeState?.[key] : getParam(key);
    const defaultValue = defaultValuesByParam[key];
    // @ts-expect-error cannot use empty object as index type
    acc[key] = value ?? defaultValue;
    return acc;
  }, {}) as RouteParams[RouteKey];
};
